<!-- <div  class="mb-3">
    <span class="mb-3 ml-3 edge-text-secondary"><strong>Post Details</strong></span>
</div> -->


<div class="pl-3" class="left-border ml-5">

    <div class="my-3 row align-items-center ml-0 py-3 creative-border">
        <div class="col-lg-6 col-12 px-2 text-center d-flex align-items-center">
            <label class="my-0 font-weight-bold pl-3">Campaign Details</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2" *ngIf="creative.creativeTypeId == creativeTypes.Social_Lead_Generation_Premium">
        <div class="col-lg-3 col-12">
            <label><strong>Additional Engagement Element</strong></label>
        </div>
        <div class="col-lg-9 col-12">
            <p-dropdown class="mr-0 pr-0" [style]="{width: '90%'}" (onChange)="setSweepstakesCategory($event)" *ngIf="!reviewPage && campaign.campaignStatusId == 1" autoWidth="false" [(ngModel)]="creative.detailSocialCampaignJson.additionalEngagementElement" [options]="sweepstakesCategoryDD"></p-dropdown>
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1 " class="mr-0 pr-0">{{sweepstakesCategoryLabel}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2" *ngIf="creative.creativeTypeId == creativeTypes.Social_Lead_Generation_Premium && sweepstakesCategoryLabel == 'Other'">
        <div class="col-lg-3 col-12">
            <label><strong>Other Additional Engagement Element
                <span class="text-danger">*</span>
            </strong></label>
        </div>
        <div class="col-lg-9 col-12 input-box">
            <input class="form-control" *ngIf="!reviewPage && campaign.campaignStatusId == 1" type="text" [(ngModel)]="creative.detailSocialCampaignJson.otherAdditionalEngagementText" [title]="creative.detailSocialCampaignJson.otherAdditionalEngagementText" style="overflow: hidden; text-overflow: ellipsis;">
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0">{{creative.detailSocialCampaignJson.otherAdditionalEngagementText}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2" *ngIf="creative.creativeTypeId != creativeTypes.Snap_AR">
        <div class="col-lg-3 col-12">
            <label><strong>Campaign Title
                <span class="text-danger">*</span></strong>
            </label>
        </div>
        <div class="col-lg-9 col-12 input-box">
            <input class="form-control" *ngIf="!reviewPage && campaign.campaignStatusId == 1 " type="text" [(ngModel)]="creative.detailSocialCampaignJson.campaignTitle" [title]="creative.detailSocialCampaignJson.campaignTitle" style="overflow: hidden; text-overflow: ellipsis;">
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1 " class="mr-0 pr-0">{{creative.detailSocialCampaignJson.campaignTitle}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2">
        <div class="col-lg-3 col-12">
            <div class="row col-lg-12 col-12">
                <label class="mb-0"><strong>Concept and Objective(s)
                    <span class="text-danger">*</span>
                </strong></label>
            </div>
            <div class="row col-lg-12 col-12">
                <span id="spanToolTip">*Please be as detailed as possible.</span>
            </div>
        </div>
        <div class="col-lg-9 col-12">
            <div class="input-box">
                <input class="form-control" maxlength="1500" *ngIf="!reviewPage && campaign.campaignStatusId == 1" type="text" [(ngModel)]="creative.detailSocialCampaignJson.conceptObjective" [title]="creative.detailSocialCampaignJson.conceptObjective" style="overflow: hidden; text-overflow: ellipsis;">
                <span *ngIf="!reviewPage && campaign.campaignStatusId == 1" class="text-right mt-1 text-muted small">
                    {{ (creative.detailSocialCampaignJson.conceptObjective || '').length }}/1500
                </span>
            </div>
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0 wrap-text">{{creative.detailSocialCampaignJson.conceptObjective}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2" *ngIf="creative.creativeTypeId != creativeTypes.Snap_AR && creative.creativeTypeId != creativeTypes.Digital_Game && creative.creativeTypeId != creativeTypes.Content && creative.creativeTypeId != creativeTypes.Social_Lead_Generation_Premium">
        <div class="col-lg-3 col-12">
            <label><strong>Detailed Prize Description
                <span class="text-danger">*</span>
            </strong></label>
        </div>
        <div class="col-lg-9 col-12">
            <div class="input-box">
                <input class="form-control" maxlength="7000" *ngIf="!reviewPage && campaign.campaignStatusId == 1" type="text" [(ngModel)]="creative.detailSocialCampaignJson.detailedPrizeDescription" [title]="creative.detailSocialCampaignJson.detailedPrizeDescription" style="overflow: hidden; text-overflow: ellipsis;">
                <span *ngIf="!reviewPage && campaign.campaignStatusId == 1" class="text-right mt-1 text-muted small">
                    {{ (creative.detailSocialCampaignJson.detailedPrizeDescription || '').length }}/7000
                </span>
            </div>
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0 wrap-text">{{creative.detailSocialCampaignJson.detailedPrizeDescription}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2" *ngIf="creative.creativeTypeId != creativeTypes.Snap_AR  && creative.creativeTypeId != creativeTypes.Digital_Game && creative.creativeTypeId != creativeTypes.Content && creative.creativeTypeId != creativeTypes.Social_Lead_Generation_Premium">
        <div class="col-lg-3 col-12">
            <label><strong>Total Estimated Prize Value
                <span class="text-danger">*</span>
            </strong></label>
        </div>
        <div class="col-lg-9 col-12">
            <div class="input-box">
                <input class="form-control" maxlength="700" *ngIf="!reviewPage && campaign.campaignStatusId == 1" type="text" [(ngModel)]="creative.detailSocialCampaignJson.totalEstimatePrizeValue" [title]="creative.detailSocialCampaignJson.totalEstimatePrizeValue" style="overflow: hidden; text-overflow: ellipsis;">
                <span *ngIf="!reviewPage && campaign.campaignStatusId == 1" class="text-right mt-1 text-muted small">
                    {{ (creative.detailSocialCampaignJson.totalEstimatePrizeValue || '').length }}/700
                </span>
            </div>
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0 wrap-text">{{creative.detailSocialCampaignJson.totalEstimatePrizeValue}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2" *ngIf="creative.creativeTypeId == creativeTypes.Content || creative.creativeTypeId == creativeTypes.Digital_Game">
        <div class="col-lg-3 col-12">
            <div class="row col-lg-12 col-12">
                <label class="mb-0"><strong>Content Type</strong></label>
            </div>
            
        </div>
        <div class="col-lg-9 col-12">
            <p-dropdown class="mr-0 pr-0" [style]="{width: '90%'}" (onChange)="setContentType($event)" *ngIf="!reviewPage && campaign.campaignStatusId == 1" autoWidth="false" [(ngModel)]="creative.detailSocialCampaignJson.contentType" [options]="contentTypeDD"></p-dropdown>
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0">{{contentTypeLabel}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2" *ngIf="creative.creativeTypeId == creativeTypes.Content && contentTypeLabel == 'Other'">
        <div class="col-lg-3 col-12">
            <label><strong>Other Content Type
                <span class="text-danger">*</span>
            </strong></label>
        </div>
        <div class="col-lg-9 col-12 input-box">
            <input class="form-control" *ngIf="!reviewPage && campaign.campaignStatusId == 1" type="text" [(ngModel)]="creative.detailSocialCampaignJson.otherContentTypeText" [title]="creative.detailSocialCampaignJson.otherContentTypeText" style="overflow: hidden; text-overflow: ellipsis;">
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0">{{creative.detailSocialCampaignJson.otherContentTypeText}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2" *ngIf="(creative.creativeTypeId == creativeTypes.Content || creative.creativeTypeId == creativeTypes.Digital_Game) && contentTypeLabel == 'Traffic Driver'">
        <div class="col-lg-3 col-12">
            <label><strong>Link</strong></label>
        </div>
        <div class="col-lg-9 col-12">
            <div class="input-box">
                <input class="form-control" maxlength="2000" *ngIf="!reviewPage && campaign.campaignStatusId == 1" type="text" [(ngModel)]="creative.detailSocialCampaignJson.contentTypeLink" [title]="creative.detailSocialCampaignJson.contentTypeLink" style="overflow: hidden; text-overflow: ellipsis;" placeholder="Click Thru Website URL">
                <span *ngIf="!reviewPage && campaign.campaignStatusId == 1" class="text-right mt-1 text-muted small">
                    {{ (creative.detailSocialCampaignJson.contentTypeLink || '').length }}/2000
                </span>
            </div>
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0 wrap-text">{{creative.detailSocialCampaignJson.contentTypeLink}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2" *ngIf="creative.creativeTypeId == creativeTypes.Social_Lead_Generation_Premium || creative.creativeTypeId == creativeTypes.Social_Lead_Generation">
        <div class="col-lg-3 col-12">
            <label><strong>Link to Sponsor's Privacy Policy
                <span class="text-danger">*</span>
            </strong></label>
        </div>
        <div class="col-lg-9 col-12">
            <div class="input-box">
                <input class="form-control" maxlength="500" *ngIf="!reviewPage && campaign.campaignStatusId == 1" type="text" [(ngModel)]="creative.detailSocialCampaignJson.sponsorPrivacyPolicyLink" [title]="creative.detailSocialCampaignJson.sponsorPrivacyPolicyLink" style="overflow: hidden; text-overflow: ellipsis;">
                <span *ngIf="!reviewPage && campaign.campaignStatusId == 1" class="text-right mt-1 text-muted small">
                    {{ (creative.detailSocialCampaignJson.sponsorPrivacyPolicyLink || '').length }}/500
                </span>
            </div>
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0 wrap-text">{{creative.detailSocialCampaignJson.sponsorPrivacyPolicyLink}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2" *ngIf="creative.creativeTypeId == creativeTypes.Social_Lead_Generation_Premium || creative.creativeTypeId == creativeTypes.Social_Lead_Generation">
        <div class="col-lg-3 col-12">
            <label><strong>Sponsor's Mailing Address
                <span class="text-danger">*</span>
            </strong></label>
        </div>
        <div class="col-lg-9 col-12">
            <div class="input-box">
                <input class="form-control" maxlength="500" *ngIf="!reviewPage && campaign.campaignStatusId == 1" type="text" [(ngModel)]="creative.detailSocialCampaignJson.sponsorMailingAddress" [title]="creative.detailSocialCampaignJson.sponsorMailingAddress" style="overflow: hidden; text-overflow: ellipsis;">
                <span *ngIf="!reviewPage && campaign.campaignStatusId == 1" class="text-right mt-1 text-muted small">
                    {{ (creative.detailSocialCampaignJson.sponsorMailingAddress || '').length }}/500
                </span>
            </div>
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0 wrap-text">{{creative.detailSocialCampaignJson.sponsorMailingAddress}}</label>
        </div>
    </div>


    <div class="row align-items-center mb-2 ml-2">
        <div class="col-lg-3 col-12">
            <label><strong>Notes for Creative/Graphics</strong></label>
        </div>
        <div class="col-lg-9 col-12 input-box">
            <input class="form-control" *ngIf="!reviewPage && campaign.campaignStatusId == 1" type="text" [(ngModel)]="creative.detailSocialCampaignJson.notesCreativeGraphics" [title]="creative.detailSocialCampaignJson.notesCreativeGraphics" style="overflow: hidden; text-overflow: ellipsis;">
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0 wrap-text">{{creative.detailSocialCampaignJson.notesCreativeGraphics}}</label>
        </div>
    </div>



</div>

<div *ngIf="creative.creativeTypeId == creativeTypes.Social_Lead_Generation_Premium">
    <social-cataboom (openPreviewEvent)="openPreview($event)" [reviewPage]='reviewPage' [isApprove]='isApprove' [campaign]="campaign" [creative]="creative"></social-cataboom>
</div>